import { render, staticRenderFns } from "./RegionChatBox.vue?vue&type=template&id=fcab4b2c&scoped=true"
import script from "./RegionChatBox.vue?vue&type=script&lang=js"
export * from "./RegionChatBox.vue?vue&type=script&lang=js"
import style0 from "./RegionChatBox.vue?vue&type=style&index=0&id=fcab4b2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcab4b2c",
  null
  
)

export default component.exports